import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
import { Base64 } from 'js-base64';
import LanguageInfoEditor from '../components/language-info-editor.vue';
import GroupLegend from '../components/group-legend.vue';
import ToggleVisibleBtn from './toggle-visible-button.vue';
import CategoryMirror from './category-mirror.vue';
import AddJsonCategoryConfig from './add-json-category-config.vue';
import { jsonGroupItemMixin } from '@/views/creative/mixin/index.js';
import { cookStyle } from '../utils/i18n.js';
import categoryMixin from '../mixin/category';

export default {
  mixins: [jsonGroupItemMixin, categoryMixin],

  components: {
    LanguageInfoEditor: LanguageInfoEditor,
    GroupLegend: GroupLegend,
    ToggleVisibleBtn: ToggleVisibleBtn,
    AddJsonCategoryConfig: AddJsonCategoryConfig,
    CategoryMirror: CategoryMirror
  },

  props: {
    category: {
      type: Object,
      required: true
    },

    isSubCategory: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {};
  },


  computed: _extends({}, mapState({
    i18n: function i18n(state) {
      return state.creative.template.templateConfig.json_config.i18n || {};
    },
    i18nResource: function i18nResource(state) {
      return state.creative.template.i18nResource;
    },
    previewGroupConfig: function previewGroupConfig(state) {
      return state.creative.template.previewGroupConfig;
    },
    orientation: function orientation(state) {
      return state.creative.template.orientation;
    }
  }), {
    keyWithOrientation: function keyWithOrientation() {
      return Base64.encode(this.category.prefix + '_' + (this.orientation === 1 ? 'V' : 'H'));
    },
    textConfigHas_V_H: function textConfigHas_V_H() {
      return this.i18nResource[this.keyWithOrientation];
    },


    // 前端存储的 key 是经过 base64 转换过的
    textKey: function textKey() {
      // 先去检查带横竖屏信息的 key，如果没有则返回不带横竖屏信息的 key
      if (this.textConfigHas_V_H) {
        return this.keyWithOrientation;
      }
      return Base64.encode('' + this.category.prefix);
    },
    currentI18nResource: function currentI18nResource() {
      return (this.i18nResource[this.textKey] || []).map(function (item) {
        return _extends({}, item, {
          isDefault: false
        });
      });
    },
    previewGroupI18n: function previewGroupI18n() {
      return _.get(this.previewGroupConfig, 'i18n');
    }
  }),

  methods: _extends({}, mapMutations({
    addValidator: 'creative/template/addValidator',
    updateTargetI18nResource: 'creative/template/updateTargetI18nResource'
  }), mapActions({
    updateTargetCategory: 'creative/template/updateTargetCategory',
    updateTargetLanguageAll18nResource: 'creative/template/updateTargetLanguageAll18nResource'
  }), {
    getH_V_RefKeys: function getH_V_RefKeys(key) {
      var decodedKey = Base64.decode(key);
      var isV = decodedKey.endsWith('_V');
      var isH = decodedKey.endsWith('_H');
      var properties = this.category.properties;
      // 优先读取 properties.refId（ps 产出的素材的文本节点关联关心存储在 properties 中）
      // refKeys：需要联动更新的文本属性的 key，默认先检查 properties.refKeys，没有则使用 category.prefix
      var refKeys = !_.isEmpty(_.get(properties, 'refKeys')) ? _.get(properties, 'refKeys') : [this.category.prefix];

      return { isV: isV, isH: isH, refKeys: refKeys };
    },
    handleLanguageInfoSubmit: function handleLanguageInfoSubmit(_ref, index) {
      var model = _ref.model,
          local = _ref.local,
          key = _ref.key;

      var style = cookStyle(_.cloneDeep(model.style || null));
      var newData = {
        value: model.value,
        style: style
      };
      this.update({
        key: key,
        local: local,
        model: newData
      }, index);
    },
    update: function update(_ref2, index) {
      var _this = this;

      var model = _ref2.model,
          local = _ref2.local,
          key = _ref2.key;

      var _getH_V_RefKeys = this.getH_V_RefKeys(key),
          isV = _getH_V_RefKeys.isV,
          isH = _getH_V_RefKeys.isH,
          refKeys = _getH_V_RefKeys.refKeys;

      _.each(refKeys, function (keyItem) {
        if (_this.textConfigHas_V_H) {
          var key_V = Base64.encode(keyItem + '_V');
          var key_H = Base64.encode(keyItem + '_H');
          if (isV) {
            _this.updateTargetI18nResource({
              key: key_V,
              index: index,
              language: local,
              value: model
            });
            // 横竖屏的文本值要同步更新(样式不同步更新)
            _this.updateTargetI18nResource({
              key: key_H,
              index: index,
              language: local,
              value: {
                value: model.value
              }
            });
          } else if (isH) {
            _this.updateTargetI18nResource({
              key: key_H,
              index: index,
              language: local,
              value: model
            });
            // 横竖屏的文本值要同步更新(样式不同步更新)
            _this.updateTargetI18nResource({
              key: key_V,
              index: index,
              language: local,
              value: {
                value: model.value
              }
            });
          }
        } else {
          _this.updateTargetI18nResource({
            key: key,
            index: index,
            language: local,
            value: model
          });
        }
      });
    },


    // 一键应用到语言、一键应用到横/竖屏
    handleApplyBtnSubmit: function handleApplyBtnSubmit(_ref3, index) {
      var model = _ref3.model,
          local = _ref3.local,
          key = _ref3.key,
          type = _ref3.type;

      var style = cookStyle(_.cloneDeep(model.style || null));
      var newData = {
        value: model.value,
        style: style
      };
      this.applyUpdate({
        key: key,
        local: local,
        model: newData
      }, index, type);
    },


    // 应用到同语言的所有文本
    applyFontToOtherTextNode: function applyFontToOtherTextNode(_ref4) {
      var model = _ref4.model,
          local = _ref4.local;

      this.updateTargetLanguageAll18nResource({
        style: model.style,
        language: local
      });
      this.$message.success(this.$t('basic.fontLoader.applyFontSuccess'));
    },


    // eslint-disable-next-line max-params
    updateScreenResource: function updateScreenResource(key, index, local, model) {
      this.updateTargetI18nResource({
        key: key,
        index: index,
        language: local,
        value: model
      });
    },
    applyUpdate: function applyUpdate(_ref5, index, type) {
      var model = _ref5.model,
          local = _ref5.local,
          key = _ref5.key;

      var _this2 = this;

      var _getH_V_RefKeys2 = this.getH_V_RefKeys(key),
          isV = _getH_V_RefKeys2.isV,
          isH = _getH_V_RefKeys2.isH,
          refKeys = _getH_V_RefKeys2.refKeys;

      _.each(refKeys, function (keyItem) {
        var key_V = Base64.encode(keyItem + '_V');
        var key_H = Base64.encode(keyItem + '_H');
        if (type === 'applyToScreen') {
          if (isV) {
            _this2.updateScreenResource(key_H, index, local, model);
          } else if (isH) {
            _this2.updateScreenResource(key_V, index, local, model);
          }
        } else if (type === 'applyToLanguage') {
          // 应用到语言，除字体、字号，其他全部应到其他语言的横竖屏
          var i18nItem = _this2.i18nResource[key][index].data;
          for (var languageKey in i18nItem) {
            if (local !== languageKey) {
              // 应用到同屏幕，其他语言
              var oldStyle = i18nItem[languageKey].style;
              var languageItemStyle = _extends({}, model.style, {
                font: oldStyle.font,
                fontSize: oldStyle.fontSize
              });
              _this2.updateScreenResource(key, index, languageKey, {
                style: languageItemStyle
              });
            }
          }
          // 先去检查带横竖屏信息的 key，如果没有则无需单独处理横竖屏的样式
          if (_this2.textConfigHas_V_H) {
            // 应用到横/竖屏
            var key_H_V = '';
            if (isV) {
              key_H_V = key_H;
            } else if (isH) {
              key_H_V = key_V;
            }
            var i18nItem_H_V = _this2.i18nResource[key_H_V][index].data;
            for (var _languageKey in i18nItem_H_V) {
              var _oldStyle = i18nItem_H_V[_languageKey].style;
              var _languageItemStyle = _extends({}, model.style, {
                font: _oldStyle.font,
                fontSize: _oldStyle.fontSize
              });
              _this2.updateScreenResource(key_H_V, index, _languageKey, {
                style: _languageItemStyle
              });
            }
          }
        }
      });
      // 提示分离出来，防止联动资源多次提示
      if (type === 'applyToScreen') {
        if (isV) {
          this.$message.success(this.$t('playTurbo.custom.textEditButton.ScreenAlert[0]'));
        } else if (isH) {
          this.$message.success(this.$t('playTurbo.custom.textEditButton.ScreenAlert[1]'));
        }
      } else if (type === 'applyToLanguage') {
        this.$message.success(this.$t('playTurbo.custom.textEditButton.languageAlert'));
      }
    }
  })
};